// crudUtil.ts
import api from "./apiClient";

export interface CrudOptions {
  signal?: AbortSignal;
  headers?: Record<string, string>;
  withCredentials?: boolean;
}

export const crudUtil = {
  get: async <T = any>(
    endpoint: string,
    params: Record<string, any> = {},
    options: CrudOptions = {}
  ): Promise<T> => {
    const { signal, headers = {}, withCredentials } = options;

    const { data } = await api.get<T>(endpoint, {
      params,
      headers,
      signal,
      withCredentials,
    });
    return data;
  },

  post: async <T = any, P = any>(
    endpoint: string,
    payload: P,
    options: CrudOptions = {}
  ): Promise<T> => {
    const { signal, headers = {}, withCredentials } = options;

    const { data } = await api.post<T>(endpoint, payload, {
      headers,
      signal,
      withCredentials,
    });
    return data;
  },

  put: async <T = any, P = any>(
    endpoint: string,
    payload: P,
    options: CrudOptions = {}
  ): Promise<T> => {
    const { signal, headers = {}, withCredentials } = options;

    const { data } = await api.put<T>(endpoint, payload, {
      headers,
      signal,
      withCredentials,
    });
    return data;
  },

  delete: async <T = any>(
    endpoint: string,
    options: CrudOptions = {}
  ): Promise<T> => {
    const { signal, headers = {}, withCredentials } = options;

    const { data } = await api.delete<T>(endpoint, {
      headers,
      signal,
      withCredentials,
    });
    return data;
  },
};
